/* Lovable "jcked-listicle-studio" pages (snippets/lbn-*.liquid): their behaviour, rebuilt without React.
   - Countdown: data-lb-seconds from the first visit, kept in localStorage under data-lb-key (the same keys as the
     Lovable pages), restarts when it ends.
   - Where the page has them: gold read-progress bar, table of contents (current reason highlighted, read ones ticked),
     phone bottom bar that slides in after 900px of scrolling. */
(function () {
  var page = document.querySelector('.lb-page');
  if (!page) return;
  var SECONDS = Number(page.getAttribute('data-lb-seconds')) || 3600;
  var KEY = page.getAttribute('data-lb-key') || 'jcked-lv-deal-end';

  function pad(n) { return String(n).padStart(2, '0'); }
  var end = 0;
  try { end = Number(localStorage.getItem(KEY)) || 0; } catch (e) { /* storage blocked */ }
  function restart() {
    end = Date.now() + SECONDS * 1000;
    try { localStorage.setItem(KEY, String(end)); } catch (e) { /* storage blocked */ }
  }
  if (!end || end < Date.now()) restart();
  var digits = page.querySelectorAll('[data-lb-t]');
  var clocks = page.querySelectorAll('[data-lb-clock]');
  function tick() {
    var left = Math.max(0, Math.round((end - Date.now()) / 1000));
    var t = { h: pad(Math.floor(left / 3600)), m: pad(Math.floor((left % 3600) / 60)), s: pad(left % 60) };
    digits.forEach(function (d) { d.textContent = t[d.getAttribute('data-lb-t')]; });
    clocks.forEach(function (c) { c.textContent = t.h + ':' + t.m + ':' + t.s; });
  }
  tick();
  setInterval(tick, 1000);

  var bar = page.querySelector('[data-lb-progress]');
  var bottom = page.querySelector('[data-lb-bottom]');
  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (bar) bar.style.width = (max > 0 ? (window.scrollY / max) * 100 : 0) + '%';
    if (bottom) {
      var show = window.scrollY > 900;
      bottom.classList.toggle('translate-y-0', show);
      bottom.classList.toggle('translate-y-full', !show);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var links = page.querySelectorAll('[data-lb-nav]');
  var labels = [];
  links.forEach(function (a) { labels.push(a.textContent.replace(/^\d+\.\s*/, '')); });
  var STATES = ['bg-ochre', 'text-ink-foreground', 'text-ochre', 'text-muted-foreground', 'hover:text-foreground'];
  function setCurrent(cur) {
    links.forEach(function (a, i) {
      var n = i + 1;
      STATES.forEach(function (c) { a.classList.remove(c); });
      if (cur === n) { a.classList.add('bg-ochre', 'text-ink-foreground'); }
      else if (cur > n) { a.classList.add('text-ochre'); }
      else { a.classList.add('text-muted-foreground', 'hover:text-foreground'); }
      a.textContent = (cur > n ? '✓ ' : n + '. ') + labels[i];
    });
  }
  if (links.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) setCurrent(Number(e.target.id.slice(1))); });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a, i) {
      var el = document.getElementById('r' + (i + 1));
      if (el) io.observe(el);
    });
  }
})();
